import { render, staticRenderFns } from "./SearchPosturasByPlate.vue?vue&type=template&id=da47f612&scoped=true"
import script from "./SearchPosturasByPlate.vue?vue&type=script&lang=js"
export * from "./SearchPosturasByPlate.vue?vue&type=script&lang=js"
import style0 from "./SearchPosturasByPlate.vue?vue&type=style&index=0&id=da47f612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da47f612",
  null
  
)

export default component.exports